import { FF_C4C_INC_VIDEO_CHAT } from '@/constants/featureFlags';
import { VIDEO_CONSULTATION_TRIGGER_D2D, VIDEO_CONSULTATION_TRIGGER_INC } from '@montugroup/clinic-telecom';
import useFeatureFlags from './useFeatureFlags';

export const useDisplayChatForIc = (videoConsultationTrigger: string | null) => {
  const { flags } = useFeatureFlags();
  const trigger = videoConsultationTrigger?.toLowerCase().trim();

  // Chat is not supported for d2d yet, it will get its own flag when it is
  if (trigger === VIDEO_CONSULTATION_TRIGGER_D2D) {
    return { displayChatForIc: false };
  }

  const isIncConsultation = trigger === VIDEO_CONSULTATION_TRIGGER_INC;
  const displayChatForIc = isIncConsultation ? flags[FF_C4C_INC_VIDEO_CHAT] : true;

  return { displayChatForIc };
};
